import { FlexDetails } from 'ggApp/types/graphql';

import ActionTypes from './actionTypes';

interface CreateSubscriptionDetailsCardAction {
    type: typeof ActionTypes.CREATE_SUBSCRIPTION_DETAILS_CARD;
    payload: FlexDetails;
}

interface UpdateSubscriptionDetailsCardAction {
    type: typeof ActionTypes.UPDATE_SUBSCRIPTION_DETAILS_CARD;
    payload: Partial<FlexDetails>;
}

export function createSubscriptionDetailsCard(
    detailsCard: FlexDetails,
): CreateSubscriptionDetailsCardAction {
    return {
        type: ActionTypes.CREATE_SUBSCRIPTION_DETAILS_CARD,
        payload: detailsCard,
    };
}

export function updateSubscriptionDetailsCard(
    detailsCard: Partial<FlexDetails>,
): UpdateSubscriptionDetailsCardAction {
    return {
        type: ActionTypes.UPDATE_SUBSCRIPTION_DETAILS_CARD,
        payload: detailsCard,
    };
}

export type Action = CreateSubscriptionDetailsCardAction | UpdateSubscriptionDetailsCardAction;

export type ActionCreator =
    | typeof createSubscriptionDetailsCard
    | typeof updateSubscriptionDetailsCard;
